var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('a-config-provider',{attrs:{"locale":_vm.locale,"size":"large"}},[_c('a-spin',{attrs:{"spinning":_vm.loading,"tip":"加载中..."}},[_c('router-view')],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }